import { z } from 'zod'

// Режим круговой диаграммы. matrix — деньги по матрицам поставщиков (на
// request_items.matrix), остальные — count клиентов с хоть одним ORDERED.
export const AnalyticsModeSchema = z.enum(['matrix', 'category', 'segment', 'city'])
export type AnalyticsMode = z.infer<typeof AnalyticsModeSchema>

// Фильтр работает на полях clients-таблицы (не на matrix). Один фильтр на mode,
// перезаписывается при повторном выборе.
export const AnalyticsFilterModeSchema = z.enum(['category', 'segment', 'city'])
export type AnalyticsFilterMode = z.infer<typeof AnalyticsFilterModeSchema>

export interface AnalyticsFilter {
  mode: AnalyticsFilterMode
  value: string
}

export interface ClientsAnalyticsItem {
  /** Ключ группы: матрица / категория / сегмент / город. */
  key: string
  /** Значение: ₽ для matrix, количество клиентов для остальных. */
  value: number
  /** Процент от total. */
  percent: number
}

export interface ClientsAnalyticsResponse {
  mode: AnalyticsMode
  /** 'rub' для matrix, 'clients' для category/segment/city. Фронт пишет «₽» или «клиентов» в центре donut. */
  unit: 'rub' | 'clients'
  total: number
  items: ClientsAnalyticsItem[]
}

export interface ClientsHeatmapResponse {
  /** Сегменты, у которых есть хотя бы один клиент с заказом в периоде (после фильтров). */
  segments: string[]
  /** Города, аналогично — только непустые. */
  cities: string[]
  /** Кол-во клиентов по парам (сегмент → город). */
  matrix: Record<string, Record<string, number>>
  rowTotals: Record<string, number>
  colTotals: Record<string, number>
  total: number
}

export interface ClientsCityCount {
  /** Нормализованное название города. */
  city: string
  /** Кол-во клиентов в этом городе. */
  count: number
}

export interface ClientsCitiesResponse {
  /** Города с количеством клиентов, сортировка по убыванию count. */
  cities: ClientsCityCount[]
  /** Кол-во клиентов без указанного города. */
  noCity: number
  /** Всего клиентов в выборке. */
  total: number
}
